import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';

type QueryValue = string | string[] | undefined;
type ReturnValue = [QueryValue, (value: QueryValue) => void];

export const useQueryValue = (queryKey: string, initialValue?: QueryValue): ReturnValue => {
	const navigate = useNavigate();
	const location = useLocation();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });
	const value = query[queryKey] as QueryValue;

	useEffect(() => {
		if (initialValue !== undefined) {
			setValue(initialValue);
		}
	}, [initialValue]);

	const setValue = (newValue: QueryValue) => {
		const newQuery = { ...query, [queryKey]: newValue };
		if (newValue === undefined) {
			delete newQuery[queryKey];
		}

		const newSearch = qs.stringify(newQuery, {
			addQueryPrefix: true,
			arrayFormat: 'repeat',
		});

		navigate({ search: newSearch }, { replace: true });
	};

	return [value, setValue];
};
